<template>
  <div class="app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start">
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="'80px'">
              <el-form-item :label="$t('carMonitor.terminalBatch.taskName')+'：'">
                <el-input v-model="listQuery.operationname" clearable :placeholder="$t('carMonitor.terminalBatch.taskName')" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="addVisible=true"
      @click-filter="showfilter=true"
      @click-addOBDTask="addOBDTask"
      @click-look="lookSuccessTask"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      show-overflow-tooltip
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="55">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable">
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('carMonitor.terminalBatch.function')" align="center" width="200">
        <template slot-scope="scope">
          <el-tag @click="lookInfo(scope.row,1)">
            {{ $t('carMonitor.terminalBatch.see') }}
          </el-tag>
          &nbsp;
          <el-tag @click="cancelBatch(scope.row)">
            {{ $t('public.cancel') }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <look-commond-dialog :visibles.sync="lookCommondVisible" :data="lookData" />
    <look-task-dialog :visibles.sync="lookTaskVisible" @cancelSuccess="listLoad" :data="lookData" />
    <add-task-dialog :visibles.sync="addVisible" :data="lookData" @add-complete="listLoad" />
    <add-obd-task-dialog :visibles.sync="addOBDVisible" :data="lookData" @add-complete="listLoad" />
    <look-obd-dialog :visibles.sync="lookObdVisible" />
  </div>
</template>

<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'

import lookCommondDialog from './components/lookCommondDialog'
import lookTaskDialog from './components/lookTaskDialog'
import addTaskDialog from './components/addTaskDialog'
import addObdTaskDialog from './components/addObdTaskDialog'
import lookObdDialog from './components/lookObdDialog'
// request
import {
  getBatchRemoteSettingPageList,
  cancelBatches
} from '@/api/carMonitor/terminalBatch'

// 辅助函数
export default {
  name: 'terminalbatch',
  components: { lookCommondDialog, lookTaskDialog, addTaskDialog, addObdTaskDialog,lookObdDialog },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {
        packetname: '',
        starttime: '',
        endtime: ''
      },
      showfilter: false,
      tableList: [
        {
          value: this.$t('carMonitor.terminalBatch.taskName'),
          prop: 'operationname',
          position: 'center',
          width: 123,
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('carMonitor.terminalBatch.loginname'),
          width: 83,
          prop: 'loginName',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('carMonitor.terminalBatch.createtime'),
          width: 150,
          prop: 'createtime',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('carMonitor.terminalBatch.paramscount'),
          prop: 'total',
          width: 153,
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        // {
        //   value: this.$t('carMonitor.terminalBatch.notperformed'),
        //   width: 113,
        //   prop: 'undoning',
        //   position: 'center',
        //   sortable: 'custom',
        //   checked: true
        // },
        // {
        //   value: this.$t('carMonitor.terminalBatch.Inprogress'),
        //   prop: 'doing',
        //   width: 113,
        //   position: 'center',
        //   sortable: 'custom',
        //   checked: true
        // },
        {
          value: this.$t('carMonitor.terminalBatch.Finishedperformed'),
          width: 102,
          prop: 'completed',
          position: 'center',
          sortable: 'custom',
          checked: true
        },
        {
          value: this.$t('carMonitor.terminalBatch.failedcount'),
          width: 143,
          prop: 'failedcount',
          position: 'center',
          sortable: 'custom',
          checked: true
        }
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      lookCommondVisible: false,
      lookTaskVisible: false,
      addVisible: false,
      lookData: {},
      addOBDVisible: false,
      lookObdVisible:false,
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    },
    lang() {
      return this.$store.getters.language
    }
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      getBatchRemoteSettingPageList(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.tableRow = {}
          this.total = data.total
          const result = data.data || []
          result.forEach(item => {
            // 0 未执行 1 执行完毕 2 执行中
            item.commond = item.sumcount === 0 ? 0 : item.doingcount === 0 ? 1 : 2
          })
          this.list = result
        }
        this.listLoading = false
      }).catch(()=>{
        this.listLoading = false
      })
    },
    lookInfo(val, type) {
      this.lookData = val
      if (type === 1) {
        this.lookTaskVisible = true
      } else {
        this.lookCommondVisible = true
      }
    },
    cancelBatch(val) {
      const operatioNname = val.operationname
        this.$confirm(this.$t('public.cancelTaskTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          cancelBatches({operationName: operatioNname}).then(({data})=>{
            if(data.code===0){
              this.listLoad()
            }
          })
        })
        .catch(() => {})
    },
    addOBDTask(){
      this.addOBDVisible = true
    },
    //查看OBD升级任务详情
    lookSuccessTask(){
      this.lookObdVisible=true
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
